import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const Gt = ({ property, onChange }) => {
  const PropertyComponent = resolveComponentForOperator(property.type, 'GT')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default Gt
